// extracted by mini-css-extract-plugin
module.exports = {"labelRename":"MenuRenameModal_labelRename__2IxKz","groupBtn":"MenuRenameModal_groupBtn__3CaMk","requiredText":"MenuRenameModal_requiredText__3ETYq"};